import { render, staticRenderFns } from "./IconCancel.vue?vue&type=template&id=0b5fbd43&scoped=true&lang=pug"
import script from "./IconCancel.vue?vue&type=script&lang=js"
export * from "./IconCancel.vue?vue&type=script&lang=js"
import style0 from "./IconCancel.vue?vue&type=style&index=0&id=0b5fbd43&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fbd43",
  null
  
)

export default component.exports